module.exports = __webpack_public_path__ + "static/cosi5-dffc4eee22c58aaf4b865861c6c28d84.jpg";